<!-- 市/区管理员-评价指标小学 -->
<template>
  <div style="width: 100%; height: 100%">
    <div class="header">
      <span>应用中心／综合评价／评价指标（小学）</span>
    </div>
    <div class="main-content">
      <div style="text-align: center">
        <el-radio-group v-model="type" size="medium" @change="changeType">
          <el-radio-button label="评价指标"></el-radio-button>
          <!-- <el-radio-button label="计分规则"></el-radio-button> -->
          <el-radio-button label="评价设置"></el-radio-button>
          <el-radio-button label="历史指标"></el-radio-button>
        </el-radio-group>
      </div>
      <div
        class="judge scroll"
        v-if="(type === '评价指标' || type === '计分规则') && !$route.params.id"
      >
        <div v-for="(item, index) in plans" :key="item.id" class="plan">
          <div
            class="plan-header"
            :style="{ background: 'url(' + backUrl[index] + ')' }"
          >
            <span>{{ item.name }}</span>
          </div>
          <div style="padding: 20px">
            <span class="suject" :title="sumEqual(item.primaryNameList)">
              <span
                v-for="(subject, index) in item.primaryNameList"
                :key="subject"
              >
                {{ subject }}
                <span v-if="index !== item.primaryNameList.length - 1">、</span>
              </span>
            </span>
            <span class="status">指标状态：{{ status(item.status) }}</span>
            <el-button
              type="primary"
              size="medium"
              plain
              style="margin-top: 30px"
              :disabled="item.status === 3"
              @click="manageStan(item)"
              >{{ item.status === 1 ? "评价指标管理" : "指标详情" }}</el-button
            >
          </div>
        </div>
      </div>
      <div
        class="nav"
        v-if="(type === '评价指标' || type === '计分规则') && $route.params.id"
      >
        <el-button
          type="text"
          style="margin: 0 20px 0 20px; font-size: 16px"
          @click="returnToTarget"
          >返回</el-button
        >
        <span style="font-weight: 500; color: #444444">{{
          incator && incator.name + "管理"
        }}</span>
      </div>
      <!-- <div class="addplan-nav" v-if="type === '评价指标' && $route.params.id">
        <div class="addplan-container">
          <span
            v-for="plan in addPlan"
            :key="plan.id"
            :class="activePlan === plan.id ? 'addplan active' : 'addplan'"
            @click="changePlan(plan)"
            >{{ plan.name }}</span
          >
        </div>
      </div> -->
      <div
        class="first-standard-container"
        v-if="type === '评价指标' && $route.params.id"
      >
        <div class="first-standard scroll">
          <span>一级指标</span>
          <span class="edit-button" v-if="!editFirstStandard">
            <el-button
              v-if="statusEdit && standards.length !== 0"
              type="primary"
              size="medium"
              plain
              @click="saveArchive"
              >评价指标存档</el-button
            >
            <template v-if="$store.state.user.level === 1">
              <el-button
                v-if="statusEdit && standards.length !== 0"
                type="primary"
                size="medium"
                plain
                @click="editStandard"
                >编辑</el-button
              >
              <el-button
                v-if="statusEdit"
                type="primary"
                size="medium"
                plain
                :disabled="standards.length === 10"
                @click="addFirstStandard"
                >+ 添加一级指标</el-button
              >
            </template>
          </span>
          <span class="edit-sure-button" v-else>
            <el-button
              type="primary"
              size="medium"
              plain
              @click="cancelEditStandard"
              >取消</el-button
            >
            <el-button
              type="primary"
              size="medium"
              @click="confirmFirstStandard"
              >确定</el-button
            >
          </span>
          <div class="standard-container" v-if="!editFirstStandard">
            <el-button
              v-for="item in standards"
              :key="item.value"
              :class="activeStandard === item.id ? 'actived' : ''"
              type="primary"
              size="medium"
              plain
              @click="clickStandard(item)"
              >{{ item.name }}</el-button
            >
          </div>
          <div class="standard-container" v-else>
            <div
              v-for="(item, index) in standards"
              :key="item.value"
              style="display: inline-block; position: relative"
            >
              <el-input
                v-model.trim="item.name"
                :maxlength="10"
                clearable
                @clear="clearStandard(item, index)"
              ></el-input>
              <span
                v-if="item.err"
                style="
                  position: absolute;
                  top: 30px;
                  left: 5px;
                  transition: all 1s ease-out;
                  color: #ed4014;
                  font-size: 12px;
                "
                >{{ item.errorMsg }}</span
              >
            </div>
          </div>
          <div style="padding: 20px">
            <el-row :gutter="24" type="flex" align="middle">
              <el-col :span="12">
                <span style="font-weight: 500">
                  <span style="color: var(--theme-color)">{{
                    firstStandardName
                  }}</span>
                  <span style="padding-left: 5px; color: #444444"
                    >二级指标配置</span
                  >
                </span>
              </el-col>
              <el-col :span="12" style="text-align: right">
                <span
                  class="edit-second-button"
                  v-if="statusEdit && standards.length !== 0"
                >
                  <el-button
                    type="primary"
                    size="medium"
                    plain
                    @click="addJudge"
                    >+ 添加二级指标</el-button
                  >
                </span>
              </el-col>
            </el-row>
            <el-row :gutter="24" style="margin-top: 20px">
              <el-col :span="24">
                <el-table
                  :data="judgeData"
                  size="medium"
                  border
                  :row-style="{ height: '40px' }"
                  :header-cell-style="{ background: '#f9f9f9' }"
                >
                  <el-table-column
                    prop="name"
                    label="二级指标名称"
                    width="200"
                  ></el-table-column>
                  <el-table-column
                    prop="pointsContent"
                    label="评价要点"
                  ></el-table-column>
                  <el-table-column
                    fixed="right"
                    v-if="statusEdit"
                    label="操作"
                    width="150"
                  >
                    <template slot-scope="scope">
                      <el-button
                        type="text"
                        @click="handleEditJudge(scope.$index, scope.row)"
                        >编辑</el-button
                      >
                      <el-button
                        type="text"
                        @click="handleDeleteJudge(scope.$index, scope.row)"
                        >删除</el-button
                      >
                    </template>
                  </el-table-column>
                </el-table>
              </el-col>
            </el-row>
          </div>
          <div style="padding: 20px">
            <el-row :gutter="24" type="flex" align="middle">
              <el-col :span="12">
                <span style="font-weight: 500">
                  <span style="color: var(--theme-color)">{{
                    firstStandardName
                  }}</span>
                  <span style="padding-left: 5px; color: #444444"
                    >记录要点配置</span
                  >
                </span>
              </el-col>
              <el-col :span="12" style="text-align: right">
                <span class="edit-second-button" v-if="!scoreSetting">
                  <el-button
                    v-if="statusEdit && standards.length !== 0"
                    type="primary"
                    size="medium"
                    plain
                    @click="setScore"
                    >分值权重设置</el-button
                  >
                  <el-button
                    v-if="statusEdit && standards.length !== 0"
                    type="primary"
                    size="medium"
                    plain
                    @click="addReport"
                    >+ 添加记录要点</el-button
                  >
                </span>
                <span class="edit-second-sure-button" v-else>
                  <el-button
                    type="primary"
                    size="medium"
                    plain
                    @click="cancelSetScore"
                    >取消</el-button
                  >
                  <el-button
                    type="primary"
                    size="medium"
                    @click="confirmScoreSet"
                    >确定</el-button
                  >
                </span>
              </el-col>
            </el-row>
            <el-row :gutter="24" style="margin-top: 20px">
              <el-col :span="24">
                <el-table
                  :data="recordData"
                  size="medium"
                  border
                  ref="presentRecord"
                  :row-style="{ height: '40px' }"
                  :header-cell-style="{ background: '#f9f9f9' }"
                >
                  <el-table-column
                    prop="indicatorPoint"
                    label="记录要点"
                    min-width="400"
                  ></el-table-column>
                  <el-table-column label="分值权重" width="100">
                    <template slot-scope="scope">
                      <span v-if="scope.row.add">-</span>
                      <span v-else>
                        <span v-if="!scope.row.editScore">{{
                          scope.row.scoreRatio
                        }}</span>
                        <el-input-number
                          v-else-if="scope.row.editScore"
                          type="textarea"
                          :id="'record-score' + scope.$index"
                          :min="0"
                          :max="100"
                          :step="1"
                          :step-strictly="true"
                          v-model.trim="scope.row.scoreRatio"
                          :controls="false"
                        ></el-input-number>
                        <span>分</span>
                        <span
                          v-if="scope.row.editScoreError"
                          style="color: #ed4014; font-size: 12px"
                          >指标名称已存在</span
                        >
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="计分规则"
                    prop="scoringRuleConfigContent"
                    width="300"
                  >
                  </el-table-column>
                  <el-table-column v-if="statusEdit" fixed="right" label="操作">
                    <template slot-scope="scope">
                      <el-button
                        :disabled="scoreSetting"
                        type="text"
                        @click="handleEditReport(scope.$index, scope.row)"
                        >编辑</el-button
                      >
                      <el-button
                        :disabled="scoreSetting"
                        type="text"
                        @click="handleDeleteReport(scope.$index, scope.row)"
                        >删除</el-button
                      >
                    </template>
                  </el-table-column>
                </el-table>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
      <!-- 计分规则 -->
      <div
        v-if="type === '计分规则' && $route.params.id"
        class="first-standard-container"
      >
        <div class="first-standard scroll">
          <span>计分规则</span>
          <span class="edit-button" style="visibility: hidden">
            <el-button
              v-if="standards.length !== 0"
              type="primary"
              size="medium"
              plain
              @click="editStandard"
              >编辑</el-button
            >
            <el-button
              type="primary"
              size="medium"
              plain
              :disabled="standards.length === 10"
              @click="addFirstStandard"
              >+ 添加一级指标</el-button
            >
          </span>
          <div class="standard-container">
            <el-button
              v-for="item in rules"
              :key="item.type"
              :class="activeRule === item.id ? 'actived' : ''"
              type="primary"
              size="medium"
              plain
              @click="clickRule(item)"
              >{{ item.name }}</el-button
            >
          </div>
          <div style="padding: 20px">
            <el-row :gutter="24" type="flex" align="middle">
              <el-col :span="12">
                <span style="font-weight: 500">
                  <span style="color: var(--theme-color)">{{ ruleName }}</span>
                  <span style="padding-left: 5px; color: #444444"
                    >得分规则配置</span
                  >
                </span>
              </el-col>
              <el-col :span="12" style="text-align: right">
                <span class="edit-second-button">
                  <el-button
                    v-if="activeRule !== lastRule && statusEdit"
                    type="primary"
                    size="medium"
                    plain
                    @click="addRule"
                    >+ 添加得分规则</el-button
                  >
                </span>
              </el-col>
            </el-row>
            <el-row :gutter="24" style="margin-top: 20px">
              <el-col :span="24">
                <el-table
                  :data="ruleData"
                  size="medium"
                  key="ruleData"
                  border
                  :row-style="{ height: '40px' }"
                  :header-cell-style="{ background: '#f9f9f9' }"
                >
                  <el-table-column
                    prop="ruleConfigName"
                    label="规则名称"
                    width="200"
                  ></el-table-column>
                  <el-table-column label="规则说明">
                    <template slot-scope="scope"
                      ><span class="text-wrapper">{{
                        scope.row.ruleDec
                      }}</span></template
                    ></el-table-column
                  >
                  <el-table-column
                    v-if="activeRule !== lastRule && statusEdit"
                    fixed="right"
                    label="操作"
                    width="150"
                  >
                    <template slot-scope="scope">
                      <el-button
                        type="text"
                        @click="handleEditRule(scope.$index, scope.row)"
                        >编辑</el-button
                      >
                    </template>
                  </el-table-column>
                </el-table>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
      <!-- 评价设置 -->
      <div v-if="type === '评价设置'" class="first-standard-container">
        <div class="first-standard scroll">
          <el-row type="flex" align="middle" class="judge-set">
            <el-col :span="12">
              <span>评价结果设置</span>
            </el-col>
            <el-col :span="12" style="text-align: right">
              <span class="edit-second-button" v-if="!edit">
                <el-button
                  type="primary"
                  plain
                  size="medium"
                  @click="editJudgeSetting"
                  >编辑</el-button
                >
              </span>
              <span class="edit-second-sure-button" v-else>
                <el-button
                  type="primary"
                  size="medium"
                  plain
                  @click="cancelJudgeSetting"
                  >取消</el-button
                >
                <el-button
                  type="primary"
                  size="medium"
                  @click="confirmJudgeSetting"
                  >确定</el-button
                >
              </span>
            </el-col>
          </el-row>
          <el-table
            :data="judgeSetData.evaluationSettingsList"
            size="medium"
            style="margin-top: 20px"
            :row-style="{ height: '40px' }"
            :header-cell-style="{ background: '#f9f9f9' }"
            :span-method="objectSpanMethod"
            border
          >
            <el-table-column prop="levelName" label="等第"></el-table-column>
            <el-table-column prop="levelDescription" label="描述">
              <template slot-scope="scope">
                <span v-if="!edit">{{ scope.row.levelDescription }}</span>
                <el-input
                  v-else
                  type="textarea"
                  autosize
                  v-model.trim="scope.row.levelDescription"
                  :class="!scope.row.levelDescription ? 'desc-error' : ''"
                  maxlength="20"
                ></el-input>
                <span v-if="!scope.row.levelDescription" class="error-tip"
                  >描述不得为空</span
                >
              </template>
            </el-table-column>
            <el-table-column prop="type" label="呈现形式">
              <template slot-scope="scope">
                <span v-if="!edit">{{
                  _.filter(types, { value: scope.row.presentType })[0].name
                }}</span>
                <span v-else>
                  <el-radio-group v-model="scope.row.presentType">
                    <el-radio
                      v-for="item in types"
                      :key="item.value"
                      :label="item.value"
                      >{{ item.name }}</el-radio
                    >
                  </el-radio-group>
                </span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <!-- 历史指标 -->
      <div class="nav" v-if="type === '历史指标' && $route.params.id">
        <el-button
          type="text"
          style="margin: 0 20px 0 20px; font-size: 16px"
          @click="returnToTarget"
          >返回</el-button
        >
        <span style="font-weight: 500; color: #444444">{{
          incator && incator.name + "详情"
        }}</span>
      </div>
      <div
        v-if="type === '历史指标' && $route.params.id"
        class="first-standard-container"
      >
        <div class="first-standard scroll">
          <span>一级指标</span>
          <span class="edit-button" style="visibility: hidden">
            <el-button type="primary" size="medium" plain @click="saveArchive"
              >评价指标存档</el-button
            >
            <el-button type="primary" size="medium" plain>编辑</el-button>
          </span>
          <div class="standard-container">
            <el-button
              v-for="item in standards"
              :key="item.value"
              :class="activeStandard === item.id ? 'actived' : ''"
              type="primary"
              size="medium"
              plain
              @click="clickStandard(item)"
              >{{ item.name }}</el-button
            >
          </div>
          <div style="margin-top: 25px; padding: 20px">
            <span style="font-weight: 500">
              <span style="color: var(--theme-color)">{{
                firstStandardName
              }}</span>
              <span style="padding-left: 5px; color: #444444"
                >评价要点配置</span
              >
            </span>
            <span class="edit-second-button" style="visibility: hidden">
              <el-button type="primary" size="medium" plain
                >+ 添加评价要点</el-button
              >
            </span>
            <el-row :gutter="24" style="margin-top: 20px">
              <el-col :span="24">
                <el-table
                  :data="judgeData"
                  size="medium"
                  border
                  :row-style="{ height: '40px' }"
                  :header-cell-style="{ background: '#f9f9f9' }"
                >
                  <el-table-column
                    prop="name"
                    label="二级指标名称"
                    width="200"
                  ></el-table-column>
                  <el-table-column
                    prop="pointsContent"
                    label="评价要点"
                  ></el-table-column>
                </el-table>
              </el-col>
            </el-row>
            <el-row :gutter="24" type="flex" align="middle" style="margin-top: 20px">
              <el-col :span="12">
                <span style="font-weight: 500">
                  <span style="color: var(--theme-color)">{{
                    firstStandardName
                  }}</span>
                  <span style="padding-left: 5px; color: #444444"
                    >记录要点配置</span
                  >
                </span>
              </el-col>
              <el-col :span="12" style="text-align: right">
                <span class="edit-second-button" v-if="!scoreSetting">
                  <el-button
                    v-if="statusEdit && standards.length !== 0"
                    type="primary"
                    size="medium"
                    plain
                    @click="setScore"
                    >分值权重设置</el-button
                  >
                  <el-button
                    v-if="statusEdit && standards.length !== 0"
                    type="primary"
                    size="medium"
                    plain
                    @click="addReport"
                    >+ 添加记录要点</el-button
                  >
                </span>
                <span class="edit-second-sure-button" v-else>
                  <el-button
                    type="primary"
                    size="medium"
                    plain
                    @click="cancelSetScore"
                    >取消</el-button
                  >
                  <el-button
                    type="primary"
                    size="medium"
                    @click="confirmScoreSet"
                    >确定</el-button
                  >
                </span>
              </el-col>
            </el-row>
            <el-row :gutter="24" style="margin-top: 20px">
              <el-col :span="24">
                <el-table
                  :data="recordData"
                  size="medium"
                  border
                  ref="presentRecord"
                  :row-style="{ height: '40px' }"
                  :header-cell-style="{ background: '#f9f9f9' }"
                >
                  <el-table-column
                    prop="indicatorPoint"
                    label="记录要点"
                    min-width="400"
                  ></el-table-column>
                  <el-table-column label="分值权重" width="100">
                    <template slot-scope="scope">
                      <span v-if="scope.row.add">-</span>
                      <span v-else>
                        <span v-if="!scope.row.editScore">{{
                          scope.row.scoreRatio
                        }}</span>
                        <el-input-number
                          v-else-if="scope.row.editScore"
                          type="textarea"
                          :id="'record-score' + scope.$index"
                          :min="0"
                          :max="100"
                          :step="1"
                          :step-strictly="true"
                          v-model.trim="scope.row.scoreRatio"
                          :controls="false"
                        ></el-input-number>
                        <span>分</span>
                        <span
                          v-if="scope.row.editScoreError"
                          style="color: #ed4014; font-size: 12px"
                          >指标名称已存在</span
                        >
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="计分规则"
                    prop="scoringRuleConfigContent"
                    width="300"
                  >
                  </el-table-column>
                  <el-table-column v-if="statusEdit" fixed="right" label="操作">
                    <template slot-scope="scope">
                      <el-button
                        :disabled="scoreSetting"
                        type="text"
                        @click="handleEditReport(scope.$index, scope.row)"
                        >编辑</el-button
                      >
                      <el-button
                        :disabled="scoreSetting"
                        type="text"
                        @click="handleDeleteReport(scope.$index, scope.row)"
                        >删除</el-button
                      >
                    </template>
                  </el-table-column>
                </el-table>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
      <div v-if="type === '历史指标' && !$route.params.id" class="judge scroll">
        <div v-for="(item, index) in plans" :key="item.name" class="plan">
          <div
            class="plan-header"
            :style="{ background: 'url(' + backUrl[index] + ')' }"
          >
            <span>{{ item.name }}</span>
          </div>
          <div style="padding: 20px">
            <span class="suject" :title="sumEqual(item.primaryNameList)">
              <span
                v-for="(subject, index) in item.primaryNameList"
                :key="subject"
              >
                {{ subject }}
                <span v-if="index !== item.primaryNameList.length - 1">、</span>
              </span>
            </span>
            <span class="status">{{ item.updateTime }}留存</span>
            <el-button
              type="primary"
              size="medium"
              plain
              style="margin-top: 30px"
              @click="manageStan(item)"
              >{{ item.status === 1 ? "评价指标管理" : "指标详情" }}</el-button
            >
          </div>
        </div>
      </div>
    </div>

    <add-first-standard
      :visible.sync="standardVisible"
      :identify="id"
      @edit-result="initJudge()"
    ></add-first-standard>

    <add-second-standard
      :visible.sync="judgePointVisible"
      :identify="judgePointInfo"
      @edit-result="initRecord()"
    ></add-second-standard>

    <add-report-point
      :visible.sync="reportPointVisible"
      :identify="reportPointInfo"
      @edit-result="initRecord()"
    ></add-report-point>

    <add-realistic-record
      :visible.sync="realisticRecordVisible"
      :identify="realisticRecordInfo"
      @edit-result="initRuleConfig(activeRule)"
    ></add-realistic-record>

    <add-reward
      :visible.sync="rewardVisible"
      :identify="rewardInfo"
      @edit-result="initRuleConfig(activeRule)"
    ></add-reward>

    <add-level-score
      :visible.sync="levelScoreVisible"
      :identify="levelScoreInfo"
      @edit-result="initRuleConfig(activeRule)"
    ></add-level-score>
  </div>
</template>

<script>
import _ from 'lodash'
import SecondNavBar from '@/components/common/SecondNavBar'
import AddFirstStandard from '@/components/common/AddFirstStandard'
import AddSecondStandard from '@/components/common/AddSecondStandard'
import AddReportPoint from '@/components/common/AddReportPoint'
import AddRealisticRecord from '@/components/common/AddRealisticRecord'
import AddReward from '@/components/common/AddReward'
import AddLevelScore from '@/components/common/AddLevelScore'
import TermTemplate from '@/components/common/TermTemplate'
import GraduateTemplate from '@/components/common/GraduateTemplate'
export default {
  props: ['id'],

  components: {
    'second-nav-bar': SecondNavBar,
    'add-first-standard': AddFirstStandard,
    'add-second-standard': AddSecondStandard,
    'add-report-point': AddReportPoint,
    'add-realistic-record': AddRealisticRecord,
    'add-reward': AddReward,
    'add-level-score': AddLevelScore,
    'term-template': TermTemplate,
    'graduate-template': GraduateTemplate
  },

  data() {
    return {
      type: '评价指标',
      plans: [],
      subjects: [
        {
          name: '思想品德',
          value: 1
        },
        {
          name: '学业水平',
          value: 2
        },
        {
          name: '身心健康',
          value: 3
        },
        {
          name: '艺术素养',
          value: 4
        }
      ],
      editFirstStandard: false,
      activeStandard: null,
      standards: [],
      clonedStandards: [],
      judgeData: [],
      standardVisible: false,
      judgePointVisible: false,
      judgePointInfo: {},
      colors: [
        require('../../../assets/green-judge.png'),
        require('../../../assets/blue-judge.png'),
        require('../../../assets/purple-judge.png')
      ],
      backUrl: [],
      activeReport: 'term',
      dimension: [],
      judgeSetData: [],
      edit: false,
      types: [
        {
          name: '等第',
          value: 1
        },
        {
          name: '描述',
          value: 2
        }
      ],
      clonedJudgeSetData: [],
      addPlan: [],
      activePlan: '',
      scoreSetting: false,
      recordData: [],
      clonedRecordData: [],
      reportPointVisible: false,
      reportPointInfo: {},
      ruleOptions: [],
      rules: [],
      ruleData: [],
      activeRule: 1,
      realisticRecordVisible: false,
      rewardVisible: false,
      levelScoreVisible: false,
      realisticRecordInfo: {},
      rewardInfo: {},
      levelScoreInfo: {},
      levels: [
        {
          name: '省级',
          value: 1
        },
        {
          name: '市级',
          value: 2
        },
        {
          name: '区县级',
          value: 3
        },
        {
          name: '校级',
          value: 4
        }
      ]
    }
  },

  watch: {
    '$route.params.id': {
      handler(newVal, oldVal) {
        Object.assign(this.$data, this.$options.data())
        if (this.$route.query && this.$route.query.type) {
          this.type = this.$route.query.type
        }
        if (newVal) {
          this.initStandard()
          this.initRuleOption()
        } else {
          this.initPlan()
        }
      }
    }
  },

  computed: {
    _() {
      return _
    },
    firstStandardName() {
      let firstStandard = _.filter(
        this.editFirstStandard ? this.clonedStandards : this.standards,
        { id: this.activeStandard }
      )[0]
      return firstStandard && firstStandard.name
    },
    ruleName() {
      let rule = _.filter(this.rules, { value: this.activeRule })[0]
      return rule && rule.name
    },
    incator() {
      return this.$store.getters['user/getIndicatorInfo']()
    },
    statusEdit() {
      return Number(this.$route.query.status) === 1
    },
    lastRule() {
      return this.rules.length > 0 && this.rules[this.rules.length - 1].id
    }
  },

  mounted() {
    if (this.$route.params.id) {
      this.initStandard()
      this.initRuleOption()
    } else {
      this.initPlan()
    }
  },

  methods: {
    initPlan() {
      this.$xhrGet(`/eval/indicators/list-grade`, {
        schoolStage: 1,
        isHistory: this.type === '历史指标' ? true : null
      }).then(rs => {
        this.plans = rs.data
        // 处理背景url
        let temp = []
        let times = Math.ceil(this.plans.length / 3)
        for (let index = 0; index < times; index++) {
          temp.push(this.colors)
        }
        this.backUrl = _.flattenDeep(temp)
      })
    },

    initStandard() {
      this.initAddPlan()
    },

    initAddPlan() {
      this.initJudge()
    },

    initJudge() {
      this.$xhrGet(`/eval/indicators/primary/list/${this.id}`, {
        schoolStage: 1,
        schoolYear: this.schoolYear,
        isHistory: this.type === '历史指标' ? true : null
      }).then(rs => {
        this.standards = rs.data
        if (rs.data.length > 0) {
          this.activeStandard = rs.data[0].id
          this.initRecord()
        } else {
          this.judgeData = []
        }
      })
    },

    initRecord() {
      this.$xhrGet(`/eval/indicators/secondary/list/${this.activeStandard}`, {
        isHistory: this.type === '历史指标' ? true : null
      }).then(rs => {
        this.judgeData = rs.data
      })
      this.$xhrGet(`/eval/indicators/config/list/${this.activeStandard}`).then(
        rs => {
          this.recordData = rs.data
          this.$forceUpdate()
        }
      )
    },

    initRuleOption() {
      let plan = JSON.parse(sessionStorage.getItem('plan'))
      this.$xhrGet(`/eval/indicators/scoring-rule/${plan.value}`).then(rs => {
        this.rules = rs.data
        this.activeRule = rs.data[0].id
        this.initRuleConfig(rs.data[0].id)
      })
      this.$xhrGet(
        `/eval/indicators/scoring-rule-config/stage/${plan.value}`
      ).then(rs => {
        this.ruleOptions = rs.data
      })
    },

    getRuleConfig() {
      this.$xhrGet(`/eval/indicators/scoring-rule/${1}`).then(rs => {
        this.rules = rs.data
        this.activeRule = rs.data && rs.data.length > 0 && rs.data[0].id
        if (rs.data && rs.data.length > 0) {
          this.initRuleConfig(rs.data[0].id)
        } else {
          this.ruleData = []
        }
      })
      this.$xhrGet(`/eval/indicators/scoring-rule-config/stage/${1}`).then(
        rs => {
          this.ruleOptions = rs.data
        }
      )
    },

    initRuleConfig(rule) {
      let param = {
        ruleId: rule
      }
      this.$xhrGet(`/eval/indicators/scoring-rule-config`, param).then(rs => {
        this.ruleData = rs.data
      })
    },

    initJudgeConfig() {
      let plan = JSON.parse(sessionStorage.getItem('plan'))
      this.$xhrGet(`/eval/indicators/eval-setting/${plan.value}`).then(rs => {
        this.judgeSetData = rs.data
        this.judgeSetData.evaluationSettingsList = this.judgeSetData.evaluationSettingsList.map(
          row => {
            return {
              ...row,
              presentType: this.judgeSetData.presentType
            }
          }
        )
      })
    },

    changeType(val) {
      const query = { ...this.$route.query, type: val }
      this.$router.replace({ query })
      if (this.id) {
        switch (val) {
          case '评价指标':
            this.initStandard()
            break
          case '计分规则':
            this.getRuleConfig()
            break
          case '评价设置':
            this.initJudgeConfig()
            break
          case '历史指标':
            this.$router.push({
              name: 'DistrictViewPrimaryTarget',
              query: { type: val }
            })
            break
        }
      } else {
        switch (val) {
          case '评价指标':
            this.initPlan()
            break
          case '计分规则':
            this.initPlan()
            break
          case '评价设置':
            this.initJudgeConfig()
            break
          case '历史指标':
            this.initPlan()
            break
        }
      }
    },

    editStandard() {
      this.clonedStandards = _.cloneDeep(this.standards)
      this.editFirstStandard = true
    },

    saveArchive() {
      // this.$message.info('市级指标未存档下发，请继续等待')
      if (this.standards.length === 0) {
        this.$message.error('请至少添加一个一级指标再进行存档')
        return false
      }
      this.$confirm(
        `评价指标存档后，当前年级评价方案将不再支持页面修改，如有修改需求，请联系技术支持人员`,
        '提示',
        { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' }
      ).then(() => {
        this.$xhrPut(`/eval/indicators/file/${this.id}`).then(rs => {
          if (rs.code === 'SUCCESS') {
            this.isLastSuccessful = true
            this.$message.success('存档成功')
            this.$router.push({
              query: { status: 2 }
            })
            this.initStandard()
          } else if (rs.code === 'PRIMARY_INDICATORS_IS_EMPTY') {
            this.$message.error('请至少添加一个一级指标再进行存档')
          } else if (rs.code === 'INDICATORS_CONFIG_RATIO_ERROR') {
            this.$message.error(
              '存在记录要点分值权重综合不等于100分的指标，请检查修改后再进行存档'
            )
          } else if (rs.code === 'SECONDARY_INDICATORS_IS_EMPTY') {
            this.$message.error('请先完成二级指标的添加再进行指标存档')
          }
        })
      })
    },

    addFirstStandard() {
      this.standardVisible = true
    },

    cancelEditStandard() {
      this.editFirstStandard = false
      this.standards = this.clonedStandards
    },

    confirmFirstStandard() {
      let firstStandard = _.filter(this.standards, { name: '' })[0]
      if (firstStandard) {
        this.$set(firstStandard, 'err', true)
        this.$set(firstStandard, 'errorMsg', '指标名称不得为空')
        return false
      }
      let names = _.map(this.standards, 'name')
      let uniqNames = _.uniq(names)
      if (names.length !== uniqNames.length) {
        this.$message.error('指标名称已存在')
        return false
      }
      this.$xhrPost(
        `/eval/indicators/primary/list/${this.id}/save`,
        this.standards
      ).then(rs => {
        if (rs.code === 'SUCCESS') {
          this.$message.success('操作成功')
          this.editFirstStandard = false
          this.initJudge()
        } else {
          let firstStandard = _.filter(this.standards, { value: rs.data })[0]
          if (firstStandard) {
            this.$set(firstStandard, 'err', true)
            this.$set(firstStandard, 'errorMsg', '指标名称已存在')
            return false
          }
        }
      })
    },

    clickStandard(item) {
      this.activeStandard = item.id
      this.editFirstStandard = false
      this.scoreSetting = false
      this.initRecord()
    },

    clearStandard(item, index) {
      this.standards.splice(index, 1)
    },

    addJudge() {
      this.judgePointVisible = true
      this.judgePointInfo = {}
      this.$set(this.judgePointInfo, 'primaryIndicatorId', this.activeStandard)
    },

    handleEditJudge(index, row) {
      this.judgePointVisible = true
      this.judgePointInfo = row
      this.$set(this.judgePointInfo, 'primaryIndicatorId', this.activeStandard)
    },

    handleDeleteJudge(index, row) {
      this.$xhrDelete(
        `/eval/indicators/secondary/${this.activeStandard}/${row.id}`
      ).then(rs => {
        if (rs.code === 'SUCCESS') {
          this.$message.success('操作成功')
          this.initRecord()
        } else if (rs.code === 403) {
          this.$message.success('')
        }
      })
    },

    setScore() {
      this.scoreSetting = true
      this.clonedRecordData = _.cloneDeep(this.recordData)
      this.recordData = this.recordData.map(row => {
        return {
          ...row,
          add: false,
          editPoint: false,
          editRule: false,
          editScore: true
        }
      })
      this.$nextTick(() => {
        let el = document.getElementById('record-score0')
        el.focus()
      })
    },

    addReport() {
      this.reportPointVisible = true
      this.reportPointInfo = {}
      this.$set(this.reportPointInfo, 'rules', _.cloneDeep(this.rules))
      this.$set(this.reportPointInfo, 'ruleOpt', _.cloneDeep(this.ruleOptions))
      this.$set(this.reportPointInfo, 'primaryIndicatorId', this.activeStandard)
    },

    cancelSetScore() {
      this.scoreSetting = false
      this.recordData = this.clonedRecordData
    },

    confirmScoreSet() {
      let totalScore = _.sum(_.map(this.recordData, 'scoreRatio'))
      if (totalScore !== 100) {
        this.$message.error('当前分值权重总和不等于100，请重新设置')
        return false
      }
      this.$xhrPut(
        `/eval/indicators/config/score-set/${this.activeStandard}`,
        this.recordData
      ).then(rs => {
        if (rs.code === 'SUCCESS') {
          this.$message.success('操作成功')
          this.scoreSetting = false
          this.initRecord()
        }
      })
    },

    handleEditReport(index, row) {
      this.reportPointVisible = true
      this.reportPointInfo = row
      this.$set(this.reportPointInfo, 'rules', _.cloneDeep(this.rules))
      this.$set(this.reportPointInfo, 'ruleOpt', _.cloneDeep(this.ruleOptions))
      this.$set(this.reportPointInfo, 'primaryIndicatorId', this.activeStandard)
    },

    handleDeleteReport(index, row) {
      this.$xhrDelete(
        `/eval/indicators/config/${this.activeStandard}/${row.id}`
      ).then(rs => {
        if (rs.code === 'SUCCESS') {
          this.$message.success('操作成功')
          this.initRecord()
        } else if (rs.code === 403) {
          this.$message.success('')
        }
      })
    },

    manageStan(plan) {
      this.$store.commit('user/indicator', plan)
      this.$router.push({
        name: 'DistrictViewPrimaryTarget',
        params: { id: plan.id },
        query: {
          status: plan.status,
          schoolYear: plan.schoolYear,
          isHistory: this.type !== '评价指标',
          type: this.type
        }
      })
    },

    returnToTarget() {
      localStorage.removeItem('indicatorInfo')
      this.$store.commit('user/indicator', {})
      this.$router.replace({
        name: 'DistrictViewPrimaryTarget',
        query: { type: this.type }
      })
    },

    // 合并单元格
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (column.property === 'type') {
        return {
          rowspan: this.judgeSetData.evaluationSettingsList.length,
          colspan: this.judgeSetData.evaluationSettingsList.length
        }
      }
    },

    editJudgeSetting() {
      this.clonedJudgeSetData = _.cloneDeep(this.judgeSetData)
      this.edit = true
    },

    cancelJudgeSetting() {
      this.edit = false
      this.judgeSetData = this.clonedJudgeSetData
    },

    confirmJudgeSetting() {
      let descArr = _.filter(this.judgeSetData.evaluationSettingsList, function(
        o
      ) {
        return !o.levelDescription
      })
      if (descArr.length > 0) {
        this.$message.error('描述不得为空')
        return false
      }
      let judgeSetData = _.cloneDeep(this.judgeSetData)
      judgeSetData.presentType =
        judgeSetData.evaluationSettingsList[0].presentType
      let plan = JSON.parse(sessionStorage.getItem('plan'))
      this.$xhrPut(
        `/eval/indicators/eval-setting/${plan.value}`,
        judgeSetData
      ).then(rs => {
        if (rs.code === 'SUCCESS') {
          this.$message.success('操作成功')
          this.edit = false
          this.initJudgeConfig()
        }
      })
    },

    status(item) {
      // 市管理员
      if (this.$store.state.user.level && this.$store.state.user.level === 1) {
        switch (item) {
          case 1:
            return '未存档'
          case 2:
            return '已存档'
        }
      } else {
        switch (item) {
          case 1:
            return '未存档'
          case 2:
            return '已存档'
          case 3:
            return '未下发'
        }
      }
    },

    // changePlan (plan) {
    //   this.activePlan = plan.id
    //   this.editFirstStandard = false
    //   this.initJudge()
    // },

    sumEqual(arr) {
      if (!arr || arr.length === 0) {
        return false
      }
      if (Array.isArray(arr)) {
        let arrSum = ''
        arr.forEach((item, index) => {
          arrSum += item + (index !== arr.length - 1 ? '、' : '')
        })
        return arrSum
      }
    },

    clickRule(item) {
      this.activeRule = item.id
      this.initRuleConfig(this.activeRule)
    },

    addRule() {
      let checkedRule = _.filter(this.rules, { id: this.activeRule })[0].type
      if (checkedRule === 1) {
        this.realisticRecordVisible = true
        this.realisticRecordInfo = {}
        this.$set(this.realisticRecordInfo, 'scoreArr', [])
        this.$set(this.realisticRecordInfo, 'time', 0)
        this.$set(this.realisticRecordInfo, 'ruleConfigId', this.activeRule)
        this.$set(
          this.realisticRecordInfo,
          'ruleInfo',
          _.filter(this.rules, { id: this.activeRule })[0]
        )
      } else if (checkedRule === 2) {
        let clonedRow = {}
        let score = []
        for (let index = 0; index < 4; index++) {
          score.push({
            name: _.filter(this.levels, { value: index + 1 })[0].name,
            value: index + 1,
            score: [],
            times: null
          })
        }
        this.$set(clonedRow, 'scoreArr', score)
        this.$set(
          clonedRow,
          'ruleInfo',
          _.filter(this.rules, { id: this.activeRule })[0]
        )
        this.rewardInfo = clonedRow
        this.rewardVisible = true
      } else if (checkedRule === 3) {
        let clonedRow = {}
        let score = []
        for (let index = 0; index < 4; index++) {
          score.push({
            level: index + 1,
            score: index === 0 ? 100 : 0
          })
        }
        this.$set(clonedRow, 'scoreArr', score)
        this.$set(
          clonedRow,
          'ruleInfo',
          _.filter(this.rules, { id: this.activeRule })[0]
        )
        this.levelScoreInfo = clonedRow
        this.levelScoreVisible = true
      }
    },

    handleEditRule(index, row) {
      let checkedRule = _.filter(this.rules, { id: this.activeRule })[0].type
      if (checkedRule === 1) {
        this.$xhrGet(`/eval/indicators/scoring-rule-config/${row.id}`).then(
          rs => {
            let score = _.cloneDeep(rs.data.content[0].itemDetailList)
            let clonedRow = _.cloneDeep(row)
            this.$set(clonedRow, 'scoreArr', score)
            this.$set(clonedRow, 'time', score.length)
            this.$set(clonedRow, 'ruleConfigId', row.id)
            this.$set(
              clonedRow,
              'ruleInfo',
              _.filter(this.rules, { id: this.activeRule })[0]
            )
            this.realisticRecordInfo = clonedRow
            this.realisticRecordVisible = true
          }
        )
      } else if (checkedRule === 2) {
        let clonedRow = {}
        let score = []
        this.$xhrGet(`/eval/indicators/scoring-rule-config/${row.id}`).then(
          rs => {
            let contentArr = _.cloneDeep(rs.data.content)
            for (let index = 0; index < contentArr.length; index++) {
              let ele = contentArr[index]
              score.push({
                name: _.filter(this.levels, { value: ele.level })[0].name,
                value: ele.level,
                score: !ele.itemDetailList ? [] : ele.itemDetailList,
                times: !ele.recordCount ? null : ele.recordCount
              })
            }
          }
        )
        this.$set(clonedRow, 'scoreArr', score)
        this.$set(clonedRow, 'ruleConfigId', row.id)
        this.$set(
          clonedRow,
          'ruleInfo',
          _.filter(this.rules, { id: this.activeRule })[0]
        )
        this.rewardInfo = clonedRow
        this.rewardVisible = true
      } else if (checkedRule === 3) {
        this.$xhrGet(`/eval/indicators/scoring-rule-config/${row.id}`).then(
          rs => {
            let score = _.cloneDeep(rs.data.content)
            if (rs.data.content.length < 5) {
              for (
                let index = rs.data.content.length;
                index < 5 - rs.data.content.length;
                index++
              ) {
                score.push({
                  level: index + 1,
                  score: 0
                })
              }
            }
            let clonedRow = _.cloneDeep(row)
            this.$set(clonedRow, 'scoreArr', score)
            this.$set(clonedRow, 'ruleConfigId', row.id)
            this.$set(
              clonedRow,
              'ruleInfo',
              _.filter(this.rules, { id: this.activeRule })[0]
            )
            this.levelScoreInfo = clonedRow
            this.levelScoreVisible = true
          }
        )
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.main-content {
  float: right;
  height: calc(100% - 88px);
  width: calc(100% - 40px);
  padding: 20px;
  position: relative;
  background: var(--theme-background);
}
.main-content /deep/ .el-radio-button__inner {
  background: transparent;
  color: #606266;
}
.main-content /deep/ .is-active .el-radio-button__inner {
  background: var(--theme-color);
  color: #ffffff;
}
.header {
  display: flex;
  align-items: center;
  width: 100%;
  height: 48px;
  background: #ffffff;
  border-bottom: tranparent;
  box-shadow: inset 1px 1px 4px 0px rgba(0, 0, 0, 0.12);
}
.header span {
  padding-left: 20px;
  font-size: 14px;
  font-weight: 400;
  color: #757575;
}
.judge {
  max-height: calc(100% - 96px);
  margin-top: 20px;
  padding: 40px 0 0 20px;
  overflow-y: scroll;
  background: #fff;
}
.plan {
  min-height: 230px;
  width: 360px;
  margin: 0 40px 40px 0;
  border-radius: 8px;
  box-shadow: 0px 1px 8px 0px rgba(0, 0, 0, 0.08);
  float: left;
}
.plan-header {
  padding: 20px;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}
.plan-header span {
  font-size: 16px;
  font-weight: 500;
  color: #212121;
}
.suject {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2; //多行在这里修改数字即可
  overflow: hidden;
  /* autoprefixer: ignore next */
  -webkit-box-orient: vertical;
  color: #444444;
  line-height: 20px;
}
.status {
  display: block;
  margin-top: 10px;
  color: #757575;
}
.plan /deep/ .el-button--primary.is-plain {
  background: transparent;
}
.plan /deep/ .el-button.is-plain:hover {
  color: var(--theme-color);
}
.plan /deep/ .el-button.is-plain:focus {
  color: var(--theme-color);
}
.nav {
  display: flex;
  align-items: center;
  height: 48px;
  margin: 20px 0 10px 0;
  font-size: 16px;
  background: #fff;
}
.first-standard-container {
  height: calc(100% - 149px);
  margin-top: 10px;
}
.first-standard {
  max-height: 100%;
  padding: 20px;
  border-radius: 4px;
  overflow-y: scroll;
  background: #fff;
}
.edit-button /deep/ .el-button--primary.is-plain {
  background: transparent;
}
.edit-button /deep/ .el-button.is-plain:hover {
  color: var(--theme-color);
}
.edit-button /deep/ .el-button.is-plain:focus {
  color: var(--theme-color);
}
.edit-button {
  display: inline-block;
  width: calc(100% - 70px);
  text-align: right;
}
.edit-sure-button {
  display: inline-block;
  width: calc(100% - 70px);
  text-align: right;
}
.edit-sure-button /deep/ .el-button--primary.is-plain {
  background: transparent;
  color: #444444;
  border-color: #dcdfe6;
}
.standard-container {
  margin-top: 15px;
  line-height: 60px;
}
.standard-container /deep/ .el-button + .el-button {
  margin-left: 0;
}
.standard-container /deep/ .el-button--primary.is-plain {
  min-width: 120px;
  margin-right: 20px;
  background: transparent;
  color: #444444;
  border-color: #dcdfe6;
}
.standard-container /deep/ .el-button--primary.is-plain.actived {
  min-width: 120px;
  margin-right: 20px;
  background: #eeeefd;
  color: var(--theme-color);
  border-color: var(--theme-color);
}
.standard-container .el-input {
  max-width: 220px;
  margin-right: 20px;
}
.edit-second-button {
  display: inline-block;
  width: calc(100% - 180px);
  text-align: right;
}
.edit-second-button /deep/ .el-button--primary.is-plain {
  background: transparent;
}
.edit-second-button /deep/ .el-button.is-plain:hover {
  color: var(--theme-color);
}
.edit-second-button /deep/ .el-button.is-plain:focus {
  color: var(--theme-color);
}
.edit-second-sure-button {
  display: inline-block;
  width: calc(100% - 180px);
  text-align: right;
}
.edit-second-sure-button /deep/ .el-button--primary.is-plain {
  background: transparent;
  color: #444444;
  border-color: #dcdfe6;
}
.el-table--border {
  border-radius: 4px;
}
.el-input-number {
  width: 55px;
}
.report-standard-container {
  height: calc(100% - 56px);
  margin-top: 20px;
}
.text-wrapper {
  white-space: pre-wrap;
}
.error-tip {
  color: #f56c6c;
  font-size: 12px;
  line-height: 1;
}
.desc-error /deep/ textarea {
  border-color: #f56c6c;
}
/deep/ .el-table tbody tr td {
  padding: 0 !important;
}
.addplan-nav {
  display: flex;
  align-items: center;
  height: 60px;
  margin: 20px 0 10px 0;
  font-size: 16px;
  background: #fff;
}
.addplan-container {
  width: calc(100% - 200px);
  height: 60px;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
  line-height: 56px;
  padding-left: 20px;
}
.addplan {
  display: inline-block;
  margin-right: 40px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
}
.active {
  color: var(--theme-color);
  border-bottom: 4px solid var(--theme-color);
}
/deep/ .el-tab-pane {
  table > tbody > tr td {
    text-align: center !important;
    padding: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/district-admin/apply/ViewPrimaryTarget.vue